interface TabControlTab
{
	id: string;
	title: string;
	href: string;
	closeButton?: boolean;
}

class TabControl
{
	private static stack: any[] = [];
	private id: string;

	private tabs: {[key: string]: JQuery};
	private tabcontrol: JQuery;
	private tabcontent: JQuery;
	private tabul: JQuery;
	private count: number;

	constructor( tag: string = 'div', contentID: string )
	{
		this.id = contentID;

		this.tabs = {};

		this.tabcontrol = $( document.createElement( tag ) );
		this.tabcontent = $( document.createElement( 'div' ) );

		this.tabcontent.addClass( 'tab-content' );
		this.tabcontent.attr( 'id', this.id );

		this.tabul = $( document.createElement( 'ul' ) );

		this.tabul.addClass( 'nav nav-tabs' );
		this.tabul.attr( 'role', 'tablist' );

		this.tabcontrol.append( this.tabul );

		this.count = 0;
	}

	public retrieveTabControl()
	{
		return this.tabcontrol;
	}

	public retrieveTabContent()
	{
		return this.tabcontent;
	}

	public createTab( tab: TabControlTab, onCreate: (tab: JQuery) => void ): JQuery | null
	{
		'use strict';

		if ( tab.id in this.tabs )
		{
			this.tabs[ tab.id ].tab( 'show' );

			return this.tabs[ tab.id ];
		}

		const tabLi = $( document.createElement( 'li' ) );

		tabLi.attr( 'id', tab.id );
		tabLi.attr( 'role', 'presentation' );

		const a = $( document.createElement( 'a' ) );

		a.html( tab.title );
		a.attr( 'href', '#' + tab.href );
		a.attr( 'aria-controls', tab.href );
		a.attr( 'role', 'tab' );
		a.attr( 'data-toggle', 'tab' );
		a.attr( 'data-tab-binding-id', tab.href );

		a.on(
			'show.bs.tab',
			function( event )
			{
				if ( event.relatedTarget == null || event.relatedTarget == undefined )
				{
					return;
				}

				TabControl.stack.push( $( event.relatedTarget ) );
			},
		);

		tabLi.append( a );

		if ( tab.closeButton )
		{
			const closeButton = $( document.createElement( 'button' ) );

			closeButton.attr( 'type', 'button' );
			closeButton.attr( 'aria-label', 'Close' );
			closeButton.addClass( 'close' );

			const tabcontrol_tabcontrol = this;
			closeButton.on(
				'click',
				function()
				{
					tabcontrol_tabcontrol.removeTab( tab.id );
				},
			);

			const close = $( document.createElement( 'span' ) );

			close.html( '&nbsp;&times;' );

			closeButton.append( close );

			a.append( closeButton );
		}

		const tabcontent = $( document.createElement( 'div' ) );
		tabcontent.attr( 'role', 'tabpanel' );
		tabcontent.addClass( 'tab-pane' );
		tabcontent.attr( 'id', tab.href );
		tabcontent.attr( 'data-tab-binding-id', tab.id );

		this.tabcontent.append( tabcontent );

		// neuen Tab anzeigen (FIXME falls in einem Browser der Tab nicht angezeigt wird)
		// this.tabcontent.show();

		this.tabs[ tab.id ] = tabLi;

		this.tabul.append( tabLi );

		++this.count;

		a.tab( 'show' );

		onCreate( tabcontent );

		return tabcontent;
	}

	public removeTab( id: string )
	{
		if ( this.count == 1 )
		{
			return;
		}

		if ( !( id in this.tabs ) )
		{
			return;
		}

		const tabPane = $( 'div [data-tab-binding-id="' + id + '"]' );

		tabPane.remove();

		this.tabs[ id ].remove();

		delete this.tabs[ id ];

		const prev = last( TabControl.stack );

		if ( prev != undefined && prev != null )
		{
			prev.tab( 'show' );
		}

		for ( const i in TabControl.stack )
		{
			if ( TabControl.stack[ i ].attr( 'data-tab-binding-id' ) == tabPane.attr( 'id' ) )
			{
				TabControl.stack.splice( TabControl.stack.indexOf( TabControl.stack[ i ] ), 1 );
			}
		}

		// TODO Nicht sehr schön
		TabControl.stack.splice( TabControl.stack.indexOf( prev ), 1 );

		--this.count;
	}

}
